"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _configProvider = require("../config-provider/configProvider");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Layer = function Layer(_ref) {
  var children = _ref.children,
    getContainer = _ref.getContainer,
    onMounted = _ref.onMounted;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    initialized = _useState2[0],
    setInitialized = _useState2[1];
  var container = _react.default.useRef(null);
  var _useContext = (0, _react.useContext)(_configProvider.ConfigContext),
    getPopupContainer = _useContext.getPopupContainer;
  (0, _react.useEffect)(function () {
    if (!container.current) {
      if (getContainer) {
        container.current = getContainer();
      } else {
        container.current = getPopupContainer();
      }
      if (!container.current) {
        console.warn('<Layer /> getContainer() 必须返回 HTMLElement，未找到DOM,已托底到body');
        container.current = document.body;
      }
    }
    setInitialized(true);
    if (onMounted) {
      onMounted(container.current, null);
    }
    return function () {
      container.current = null;
    };
  }, []);
  if (!children || !initialized) return null;
  if (!children || !(container !== null && container !== void 0 && container.current)) return null;
  var validChild = /*#__PURE__*/_react.default.isValidElement(children) ? children : ( /*#__PURE__*/_react.default.createElement("div", null, children));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/(0, _reactDom.createPortal)(validChild, container.current));
};
Layer.displayName = 'Layer';
var _default = exports.default = Layer;